// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/background_01.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper_gallery {
  width: 65%;
  margin: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}
.swiper_gallery .filter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: blur(5px);
}
.swiper_gallery .swiper {
  width: 100%;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 790px) {
  .swiper_gallery .swiper {
    height: 150px;
  }
}
.swiper_gallery .swiper-slide {
  background-size: cover;
  background-position: center;
}
.swiper_gallery .mySwiper2 {
  width: 100%;
}
.swiper_gallery .mySwiper {
  height: 150px;
  box-sizing: border-box;
  padding: 10px 0;
}
@media (max-width: 790px) {
  .swiper_gallery .mySwiper {
    height: 60px;
  }
}
.swiper_gallery .mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 1;
  border: 0.5px solid #ffffff;
}
.swiper_gallery .mySwiper .swiper-slide-thumb-active {
  opacity: 1;
  border: 2px solid #ffffff;
}
.swiper_gallery .swiper-slide img {
  display: block;
  width: 100%;
  margin: auto;
  height: 100%;
  object-fit: cover;
}
.swiper_gallery .mySwiper2 .swiper-slide img {
  width: 80%;
}
.swiper_gallery .swiper-button {
  position: absolute;
  top: 40%;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 790px) {
  .swiper_gallery .swiper-button {
    top: 30%;
  }
}
.swiper_gallery .swiper-button svg {
  width: 2rem;
  height: 2rem;
}
@media (max-width: 790px) {
  .swiper_gallery .swiper-button svg {
    width: 1rem;
    height: 1rem;
  }
}
.swiper_gallery .image-swiper-button-prev {
  left: -5px;
}
.swiper_gallery .image-swiper-button-next {
  right: -5px;
}
.swiper_gallery .swiper-button-disabled {
  opacity: 0.5;
}
.swiper_gallery h5 {
  color: #0A0A0A;
  font-size: 35px;
  text-align: center;
  position: absolute;
  top: 0%;
  left: 50%;
  background: rgba(255, 255, 255, 0.3);
  padding: 10px;
  margin: 0;
  transform: translate(-40%, 50%);
  z-index: 111;
  font-family: hemi_head;
  text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);
}
@media (max-width: 790px) {
  .swiper_gallery h5 {
    font-size: 20px;
    transform: translate(-40%, 0%);
  }
}
@media (max-width: 500px) {
  .swiper_gallery h5 {
    font-size: 18px;
    transform: translate(-50%, 0%);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SwiperGallery/style.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,YAAA;EACA,mDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACJ;AAGE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAEI;EALF;IAME,aAAA;EACF;AACF;AAEE;EACE,sBAAA;EACA,2BAAA;AAAJ;AAGE;EAEE,WAAA;AAFJ;AAKE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAHJ;AAII;EAJF;IAKI,YAAA;EADJ;AACF;AAIE;EACE,UAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;AAFJ;AAKE;EACE,UAAA;EACA,yBAAA;AAHJ;AAME;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAJJ;AAME;EACE,UAAA;AAJJ;AAiBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAfJ;AAgBI;EALF;IAMI,QAAA;EAbJ;AACF;AAgBE;EACE,WAAA;EACA,YAAA;AAdJ;AAeI;EAHF;IAII,WAAA;IACA,YAAA;EAZJ;AACF;AAeE;EACE,UAAA;AAbJ;AAgBE;EACE,WAAA;AAdJ;AAgBE;EACE,YAAA;AAdJ;AAgBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,SAAA;EACA,+BAAA;EACA,YAAA;EACA,sBAAA;EACA,yFAAA;AAdF;AAeE;EAdF;IAeG,eAAA;IACC,8BAAA;EAZF;AACF;AAaE;EAlBF;IAmBI,eAAA;IACA,8BAAA;EAVF;AACF","sourcesContent":[".swiper_gallery {\n  width: 65%;\n  margin: auto;\n  background: url(\"../../Assets/Images/background_01.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n\n  .filter {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    filter: blur(5px);\n\n  }\n\n  .swiper {\n    width: 100%;\n    height: 400px;\n    margin-left: auto;\n    margin-right: auto;\n    @media (max-width: 790px) {\n    height: 150px;\n  }\n  }\n\n  .swiper-slide {\n    background-size: cover;\n    background-position: center;\n  }\n\n  .mySwiper2 {\n    //height: 100%;\n    width: 100%;\n  }\n\n  .mySwiper {\n    height: 150px;\n    box-sizing: border-box;\n    padding: 10px 0;\n    @media (max-width: 790px) {\n      height: 60px;\n    }\n  }\n\n  .mySwiper .swiper-slide {\n    width: 25%;\n    height: 100%;\n    opacity: 1;\n    border: 0.5px solid #ffffff;\n  }\n\n  .mySwiper .swiper-slide-thumb-active {\n    opacity: 1;\n    border: 2px solid #ffffff;\n  }\n\n  .swiper-slide img {\n    display: block;\n    width: 100%;\n    margin: auto;\n    height: 100%;\n    object-fit: cover;\n  }\n  .mySwiper2 .swiper-slide img{\n    width: 80%;\n  }\n  //.swiper-button-next,\n  //.swiper-button-prev {\n  //  background-color: white;\n  //  background-color: rgba(255, 255, 255, 0.5);\n  //  right:18px;\n  //  border-radius: 50%;\n  //  padding: 30px;\n  //  color: #000 !important;\n  //  fill: black !important;\n  //  stroke: black !important;\n  //}\n  .swiper-button {\n    position: absolute;\n    top: 40%;\n    z-index: 10;\n    cursor: pointer;\n    @media (max-width: 790px) {\n      top: 30%;\n    }\n\n  }\n  .swiper-button svg {\n    width: 2rem;\n    height: 2rem;\n    @media (max-width: 790px) {\n      width: 1rem;\n      height: 1rem;\n    }\n\n  }\n  .image-swiper-button-prev {\n    left: -5px;\n\n  }\n  .image-swiper-button-next {\n    right: -5px;\n  }\n  .swiper-button-disabled {\n    opacity: 0.5;\n  }\nh5{\n  color: #0A0A0A;\n  font-size: 35px;\n  text-align: center;\n  position: absolute;\n  top:0%;\n  left: 50%;\n  background: rgba(255,255,255,0.3);\n  padding: 10px;\n  margin: 0;\n  transform: translate(-40%,50%);\n  z-index: 111;\n  font-family: hemi_head;\n  text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);\n  @media (max-width: 790px) {\n   font-size: 20px;\n    transform: translate(-40%,0%);\n  }\n  @media (max-width: 500px) {\n    font-size: 18px;\n    transform: translate(-50%,0%);\n  }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
